import { Invoice } from '@acp/shared';
import { BorderProps, Grid } from '@chakra-ui/react';
import { InvoiceRowLayout, InvoiceRowActions } from '../../../invoice';

function GridWrapper({ children }: { children: React.ReactNode }) {
    return (
        <Grid
            gridTemplateAreas={[`
                "invoice-number invoice-number"
                "property property"
                "due-date ."
                "total ."
                "actions ."
            `, `
                "invoice-number invoice-number due-date"
                "invoice-number invoice-number total"
                "property property actions"
            `, null, '"invoice-number property due-date total actions"']}
            gridTemplateColumns={['1fr 1fr', 'min-content 1fr 1fr', null, '3fr 5fr 3fr 2fr 4fr']}
            gridTemplateRows="auto"
            gap={0}
            alignItems="center"
            justifyItems="start"
            h="auto"
        >
            {children}
        </Grid>
    );
}

export function OverdueInvoiceRow(
    {
        invoice,
        gridWrapper = GridWrapper,
        borderLeftColor,
        isHideAddress = false,
    }:
    {
        invoice: Invoice;
        gridWrapper?: React.ComponentType<{ children: React.ReactNode }>;
        borderLeftColor?: BorderProps['borderLeftColor'];
        isHideAddress?: boolean;
    }
) {
    return (
        <InvoiceRowLayout borderLeftColor={borderLeftColor}>
            <InvoiceRowLayout.Body as={gridWrapper}>
                <InvoiceRowLayout.Column area="invoice-number">
                    <InvoiceRowLayout.InvoiceIcon isPaid={invoice.isPaid} />
                    <InvoiceRowLayout.InvoiceNumber invoiceNumber={invoice.invoiceNumber} />
                </InvoiceRowLayout.Column>

                {!isHideAddress && (
                    <InvoiceRowLayout.Column area="property">
                        <InvoiceRowLayout.Address invoice={invoice} />
                    </InvoiceRowLayout.Column>
                )}

                <InvoiceRowLayout.Column area="due-date">
                    <InvoiceRowLayout.InvoiceStatus invoice={invoice} />
                </InvoiceRowLayout.Column>

                <InvoiceRowLayout.Column area="total">
                    <InvoiceRowLayout.InvoiceAmount amountIncGst={invoice.totalIncGst} />
                </InvoiceRowLayout.Column>

                <InvoiceRowLayout.Column area="actions">
                    <InvoiceRowActions invoice={invoice} />
                </InvoiceRowLayout.Column>
            </InvoiceRowLayout.Body>
        </InvoiceRowLayout>
    );
}
